export function generateRoutes(menus) {
  const routes = [];

  function extractLeafMenus(menuList, result = []) {
    menuList.forEach((menu) => {
      if (menu.menuType === "C") {
        result.push(menu);
      }
      if (menu.children && menu.children.length > 0) {
        extractLeafMenus(menu.children, result);
      }
    });
    return result;
  }

  const leafMenus = extractLeafMenus(menus);
  
  // ⭐ 打印所有叶子菜单
  console.log('所有叶子菜单:', leafMenus.map(m => ({ name: m.menuName, path: m.path, component: m.component })));

  leafMenus.forEach((menu) => {
    const route = generateRoute(menu);
    if (route) {
      route.path = menu.path.startsWith("/") ? menu.path.slice(1) : menu.path;
      console.log('生成的路由:', route.path, route.component); // ⭐ 打印生成的路由
      routes.push(route);
    }
  });

  return routes;
}
/**
 * 生成单个路由配置
 */
function generateRoute(menu) {
  console.log('🎯 generateRoute 处理菜单:', menu.menuName, 'component:', menu.component);
  
  if (menu.menuType !== "C") {
    return null;
  }

  const route = {
    path: menu.path,
    name: menu.path.replace(/\//g, "-").slice(1) || "home",
    meta: {
      title: menu.menuName,
      requiresAuth: true,
      permission: menu.permission_key,
    },
  };

  console.log('🎯 生成的路由对象(component处理前):', { path: route.path, name: route.name });

  if (menu.is_frame === 0) {
    route.component = () => import("@/views/main/error/404.vue");
    route.props = { url: menu.path };
    console.log('🎯 is_frame=0，使用404组件');
  } else {
    // ⭐ 硬编码测试 customers
    if (menu.menuName === 'customers') {
      console.log('🎯 ✅✅✅ 使用硬编码导入 customers ✅✅✅');
      route.component = () => import("@/views/sysManage/supplier/customers.vue");
    } 
    else if (menu.component) {
      try {
        console.log('🎯 调用 getRouteComponent，传入:', menu.component);
        route.component = getRouteComponent(menu.component);
        console.log('🎯 getRouteComponent 返回:', route.component);
      } catch (error) {
        console.error(`🎯 加载组件失败: ${menu.component}`, error);
        route.component = () => import("@/views/main/error/404.vue");
      }
    } else {
      console.warn('🎯 菜单没有component字段:', menu);
      route.component = () => import("@/views/main/error/404.vue");
    }
  }

  console.log('🎯 最终路由:', { path: route.path, name: route.name, hasComponent: !!route.component });
  return route;
}

/**
 * 根据组件路径获取路由组件
 */
function getRouteComponent(componentPath) {
  console.log('getRouteComponent 接收到的路径:', componentPath);
  if (!componentPath || componentPath.trim() === "") {
    return () => import("@/views/main/error/404.vue");
  }

  // 移除可能的@/前缀
  const cleanPath = componentPath.replace(/^@\//, "");

  // 已知组件映射
  const componentMap = {
    "views/sysManage/zoneManage/zoneList.vue": () =>
      import("@/views/sysManage/zoneManage/zoneList.vue"),
    "views/sysManage/typeSheepManage/typeSheepList.vue": () =>
      import("@/views/sysManage/typeSheepManage/typeSheepList.vue"),
    "views/sysManage/weightLevelManage/weightLevelList.vue": () =>
      import("@/views/sysManage/weightLevelManage/weightLevelList.vue"),
    "views/sysManage/roleManage/roleList.vue": () =>
      import("@/views/sysManage/roleManage/roleList.vue"),
    "views/sysManage/permissionManage/permissionList.vue": () =>
      import("@/views/sysManage/permissionManage/permissionList.vue"),
    "views/sysManage/userManage/userList.vue": () =>
      import("@/views/sysManage/userManage/userList.vue"),
    "views/sysManage/menuManage/menuList.vue": () =>
      import("@/views/sysManage/menuManage/menuList.vue"),
    "views/sysManage/adminRoleManage/adminRoleList.vue": () =>
      import("@/views/sysManage/adminRoleManage/adminRoleList.vue"),
    "views/sysManage/adminUserManage/adminUserList.vue": () =>
      import("@/views/sysManage/adminUserManage/adminUserList.vue"),
    "views/sysManage/supplier/customers.vue": () =>
      import("@/views/sysManage/supplier/customers.vue"),
    
  };
  console.log('映射表中是否有这个路径:', !!componentMap[cleanPath]);

  // 检查映射表
  if (componentMap[cleanPath]) {
    return componentMap[cleanPath];
  }

  // 如果不在映射中，尝试动态导入
  try {
    const importFunc = () => import(`@/${cleanPath}`);
    return importFunc;
  } catch (error) {
    console.error(`动态导入组件失败: ${cleanPath}`, error);
    return () => import("@/views/main/error/404.vue");
  }
}

/**
 * 获取路由组件路径映射（避免动态导入问题）
 */
export function getRouteComponentMap() {
  return {
    // 系统管理模块
    "views/sysManage/zoneManage/zoneList.vue": () =>
      import("@/views/sysManage/zoneManage/zoneList.vue"),
    "views/sysManage/typeSheepManage/typeSheepList.vue": () =>
      import("@/views/sysManage/typeSheepManage/typeSheepList.vue"),
    "views/sysManage/weightLevelManage/weightLevelList.vue": () =>
      import("@/views/sysManage/weightLevelManage/weightLevelList.vue"),
    "views/sysManage/roleManage/roleList.vue": () =>
      import("@/views/sysManage/roleManage/roleList.vue"),
    "views/sysManage/permissionManage/permissionList.vue": () =>
      import("@/views/sysManage/permissionManage/permissionList.vue"),
    "views/sysManage/userManage/userList.vue": () =>
      import("@/views/sysManage/userManage/userList.vue"),
    "views/sysManage/menuManage/menuList.vue": () =>
      import("@/views/sysManage/menuManage/menuList.vue"),
    "views/sysManage/adminRoleManage/adminRoleList.vue": () =>
      import("@/views/sysManage/adminRoleManage/adminRoleList.vue"),
    "views/sysManage/adminUserManage/adminUserList.vue": () =>
      import("@/views/sysManage/adminUserManage/adminUserList.vue"),
    "views/sysManage/supplier/customers.vue": () =>
      import("@/views/sysManage/supplier/customers.vue"),
   
  };
}
